import React, { useState } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/contactus.scss";

const initialForm = {
  name: "",
  email: "",
  orderNumber: "",
  topic: "",
  message: "",
};

function Contact() {
  const [formData, setFormData] = useState(initialForm);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const contact = siteConfig.contact || {};

  const updateField = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    if (isSubmitted) setIsSubmitted(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitted(true);
    setFormData(initialForm);
  };

  const contactCards = [
    contact.email && {
      label: "Email",
      value: contact.email,
      href: `mailto:${contact.email}`,
    },
    contact.address && {
      label: "Visit or write",
      value: contact.address,
    },
    contact.hours && {
      label: "Customer care hours",
      value: contact.hours,
    },
  ].filter(Boolean);

  return (
    <main className="content-page contact-page">
      <header className="page-hero">
        <div className="page-shell page-hero__content">
          <p className="eyebrow">Customer care</p>
          <h1>How can we help?</h1>
          <p className="page-hero__lede">
            Questions about an ingredient, your order, or a gift? Send us a note
            and the {siteConfig.brandName} team will be glad to help.
          </p>
        </div>
      </header>

      <section className="page-section page-shell contact-layout">
        <aside className="contact-sidebar" aria-label="Contact information">
          <div className="section-heading">
            <p className="eyebrow">Get in touch</p>
            <h2>We are here for the details</h2>
            <p>
              For order help, include your order number so we can assist you
              more quickly.
            </p>
          </div>
          <div className="contact-card-list">
            {contactCards.map((card) => (
              <article className="contact-card" key={card.label}>
                <h3>{card.label}</h3>
                {card.href ? (
                  <a href={card.href}>{card.value}</a>
                ) : (
                  <p>{card.value}</p>
                )}
              </article>
            ))}
          </div>
          <p className="contact-sidebar__note">
            Looking for delivery or return details? Read our{" "}
            <Link to="/shipping">shipping policy</Link> and{" "}
            <Link to="/returns">returns policy</Link>.
          </p>
        </aside>

        <div className="contact-form-panel">
          {isSubmitted && (
            <div className="form-notice form-notice--success" role="status">
              <h2>Your message is ready.</h2>
              <p>
                This front-end demo validated the form but did not transmit it.
                Connect a support service to enable live delivery.
              </p>
            </div>
          )}

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="contact-name">Name</label>
              <input
                id="contact-name"
                name="name"
                type="text"
                autoComplete="name"
                value={formData.name}
                onChange={updateField}
                required
              />
            </div>
            <div className="form-field">
              <label htmlFor="contact-email">Email address</label>
              <input
                id="contact-email"
                name="email"
                type="email"
                autoComplete="email"
                value={formData.email}
                onChange={updateField}
                required
              />
            </div>
            <div className="form-field">
              <label htmlFor="contact-order">
                Order number{" "}
                <span className="form-field__optional">Optional</span>
              </label>
              <input
                id="contact-order"
                name="orderNumber"
                type="text"
                autoComplete="off"
                value={formData.orderNumber}
                onChange={updateField}
              />
            </div>
            <div className="form-field">
              <label htmlFor="contact-topic">What can we help with?</label>
              <select
                id="contact-topic"
                name="topic"
                value={formData.topic}
                onChange={updateField}
                required
              >
                <option value="" disabled>
                  Choose a topic
                </option>
                <option value="order">An existing order</option>
                <option value="product">A product question</option>
                <option value="shipping">Shipping or delivery</option>
                <option value="return">A return or damaged item</option>
                <option value="other">Something else</option>
              </select>
            </div>
            <div className="form-field form-field--wide">
              <label htmlFor="contact-message">Message</label>
              <textarea
                id="contact-message"
                name="message"
                rows="7"
                value={formData.message}
                onChange={updateField}
                required
              />
            </div>
            <div className="form-field form-field--wide contact-form__footer">
              <p>
                By submitting this form, you agree to our{" "}
                <Link to="/privacy">privacy policy</Link>.
              </p>
              <button className="button button--primary" type="submit">
                Send message
              </button>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
}

export default Contact;
